
import { defineComponent, inject, onMounted, ref } from 'vue'

export default defineComponent({
  name: 'FavoriteButton',
  components: {},
  setup() {
    const emitter: any = inject('emitter')
    const isVieworder = inject('isVieworder') as boolean
    let visible = ref(true)

    onMounted(() => {
      visible.value = !isVieworder
    })

    const openDialog = (_) => {
      emitter.emit('openFavoriteDialog')
    }

    return {
      visible,
      openDialog
    }
  }
})
